<template>
    <modal @close="editMobileNumberCancelClick" hideFooter id="edit-mobile-number" style="max-width: 800px;">
        <div class="td-container">
            <h3>Edit Mobile Number</h3>

            <div v-if="isAdmin">
                <p>Enter a new mobile number for this user.</p>
                <p>
                    The changes will be applied immediately, no verification is required.
                </p>
            </div>
            <div v-else>
                <p>A verification text will be sent to the new mobile number before changes are applied.</p>
            </div>

            <label class="td-label td-text-bold mt-0">New Mobile Number:</label>
            <div class="td-banner danger slim my-1" v-if="errorMessage.length > 0">
                <icon class="icon" type="solid" name="faTriangleExclamation" aria-hidden="true"></icon>
                <div> {{ errorMessage }}</div>
            </div>

            <div v-if="isAdmin">
                <p>
                    <input type="text" v-model="newMobile" />
                </p>
                <p v-if="v$.newMobile.$error" class="td-error">Please enter a valid mobile number.</p>
                <p>
                    <button class="td-btn primary" @click="updateMobileSkip">Save</button>
                </p>

            </div>
            <div v-else>
                <AddressValidator @validated="updateMobile" @skip="updateMobileSkip"
                                  :reset="usernameResetTrigger"
                                  :disable-email="true"
                                  :disable-validation="false"
                                  :disable-password="true"
                                  :validation-failed="false"
                                  :enable-username="false" v-model="newMobile"
                                  :with-password="false"
                                  :update-existing="true"
                                  :allow-skip="newMobile == ''"
                                  placeholder="Enter mobile number">
                </AddressValidator>

                <div class="mb-2 checkboxes">
                    <label class="td-checkbox-label">
                        <i class="td-text-subdued">By checking this box, you agree to receive customer care text messages from TruckDown regarding your account and support requests.  Message frequency varies.  Message and data rates may apply.  Reply HELP for help and STOP to cancel.  Consent is not required to create an account or use TruckDown services.</i>
                        <input type="checkbox" v-model="mobileOptin" />
                        <span class="mark"></span>
                    </label>

                    <div class="td-banner danger slim mt-2" v-if="showMobileOptinError">
                        <icon class="icon" type="solid" name="faTriangleExclamation" aria-hidden="true"></icon>
                        <p>By providing your mobile number, you must consent to receive customer care text messages from TruckDown.  If you do not wish to receive these messages, remove your mobile number.</p>
                    </div>
                </div>

                <div v-if="validationResult">
                    <button class="td-btn primary td-full-width mt-2" @click.prevent="continueUpdateMobile">
                        <span class="btn-name">Continue</span>
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './EditMobileNumber';
    export default script;
</script>
<style lang="less">
    @import './EditMobileNumber.less';
</style>